import SendbirdChat from '@sendbird/chat';
import lodash from 'lodash';
import {
  GroupChannelHandler,
  GroupChannelModule,
  MyMemberStateFilter,
} from '@sendbird/chat/groupChannel';
// import { CHAT_GROUP_FETCH_COUNT } from '../containers/MessagesPage/constants';
const CHAT_GROUP_FETCH_COUNT = 10;
const { SEND_BIRD_APP_ID } = process.env;

let sendbirdChat = null;
let groupChannelQuery = null;

export const initSendbirdOnUserLogin = async (
  userId,
  userNickName,
  callback,
  messageReceiveHandler,
) => {
  try {
    if (!sendbirdChat) {
      sendbirdChat = await SendbirdChat.init({
        appId: SEND_BIRD_APP_ID,
        localCacheEnabled: false,
        modules: [new GroupChannelModule()],
      });
      const user = await sendbirdChat.connect(userId);
      if (!user.nickname)
        await sendbirdChat.updateCurrentUserInfo({ nickname: userNickName });
      await sendbirdChat.setChannelInvitationPreference(true);

      const unreadItemCount = await getTotalUnreadMessageCount();
      callback(unreadItemCount);
      addGroupChannelHandler({ onMessageReceived: messageReceiveHandler });
    }

    return console.log('Sendbird connection established');
  } catch (error) {
    return console.error('Sendbird error', error);
  }
};

export const getTotalUnreadMessageCount = async () =>
  sendbirdChat.groupChannel.getTotalUnreadMessageCount();

// does not work for use case, need total count based on our filter
export const getTotalGroupChannels = async () =>
  sendbirdChat.groupChannel.getGroupChannelCount({
    myMemberStateFilter: MyMemberStateFilter.JOINED,
  });

export const disconnectUserFromSendbird = async () => {
  try {
    await sendbirdChat.disconnect();
    sendbirdChat = null;
    return console.log('Disconnected from sendbird');
  } catch (error) {
    return null;
  }
};

export const setGroupChannelQuery = ({
  searchValue = '',
  onlyUnread = false,
  onlyFavorite = false,
}) => {
  if (sendbirdChat)
    groupChannelQuery = sendbirdChat.groupChannel.createMyGroupChannelListQuery(
      {
        limit: CHAT_GROUP_FETCH_COUNT,
        unreadChannelFilter: onlyUnread ? 'unread_message' : 'all',
        customTypesFilter: onlyFavorite ? ['FAVORITE'] : null,
        searchFilter: {
          fields: ['member_nickname', 'channel_name'],
          query: searchValue,
        },
      },
    );
};

export const hasMoreGroupChannel = () =>
  groupChannelQuery ? groupChannelQuery.hasNext : false;

export const isGroupChannelQueryInProgress = () =>
  groupChannelQuery ? groupChannelQuery.isLoading : false;

export const loadGroupChannels = async () => {
  if (!sendbirdChat || !groupChannelQuery) return [];
  if (groupChannelQuery.hasNext) return groupChannelQuery.next();
  return [];
};

export const createChannel = async (channelName, userIdsToInvite) => {
  const groupChannelParams = {};
  groupChannelParams.invitedUserIds = userIdsToInvite;
  groupChannelParams.name = channelName;
  groupChannelParams.operatorUserIds = userIdsToInvite;
  groupChannelParams.isDistinct = false;
  groupChannelParams.metadata = { isFavorite: false };

  return sendbirdChat.groupChannel.createChannel(groupChannelParams);
};

export const sendChannelTextMessage = async (
  groupChannel,
  message,
  onSendSuccess = () => {},
) => {
  const params = {
    message,
  };
  groupChannel
    .sendUserMessage(params)
    .onFailed((error) => {
      console.log({ error });
      throw Error('Failed to send message');
    })
    .onSucceeded((msg) => onSendSuccess(msg));
};

export const sendChannelFileMessage = async (
  groupChannel,
  file,
  onSendSuccess = () => {},
) => {
  const fileMessageParams = {};
  fileMessageParams.file = file;
  groupChannel
    .sendFileMessage(fileMessageParams)
    .onFailed((error) => {
      console.log(error);
      throw Error('Failed to send file message');
    })
    .onSucceeded((msg) => onSendSuccess(msg));
};

export const getChannelPreviousMessageList = async (groupChannel) => {
  const params = {
    limit: 100,
    reverse: true,
  };
  const query = groupChannel.createPreviousMessageListQuery(params);

  const messages = [];
  while (query.hasNext) {
    // eslint-disable-next-line no-await-in-loop
    const list = await query.load();
    messages.push(...list);
  }

  return messages;
};

export const markGroupChannelAsRead = async (groupChannel) => {
  await groupChannel.markAsRead();
};

export const addGroupChannelHandler = ({ onMessageReceived }) => {
  if (sendbirdChat) {
    const channelHandler = new GroupChannelHandler();
    channelHandler.onMessageReceived = (channel, message) => {
      onMessageReceived(channel, message);
    };
    sendbirdChat.groupChannel.addGroupChannelHandler(
      lodash.random().toString(),
      channelHandler,
    );
  }
};

export const updateGroupChannel = async (groupChannel, params) => {
  const groupChannelParams = { ...params };
  return groupChannel.updateChannel(groupChannelParams);
};
